import MSIcon from "../../components/Icons/MSIcon";
import { Button } from "antd";
import { LoginWrapper } from "./LoginStyled";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { ApiUrl } from "../../utils/constants/ApiUrl";

const SignInUICardStyled = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const [authError, setAuthError] = useState<string | null>(null);

  const handleLogin = () => {
    window.location.assign(
      `${process.env.REACT_APP_BASE_URL}${ApiUrl.oidcAuthenticate}`,
    );
  };

  useEffect(() => {
    if (location.state?.authError) {
      setAuthError(location.state.authError);

      // Clear router state AFTER copying it
      navigate(location.pathname, {
        replace: true,
        state: null,
      });
    }
  }, [location.state, navigate, location.pathname]);

  return (
    <LoginWrapper>
      <div className="login">
        <div>
          <h4>{"Sign in"}</h4>
          <p className="info">{"Welcome! Please sign in to continue."}</p>
        </div>
        <Button icon={<MSIcon />} onClick={handleLogin}>
          {"Sign in with Microsoft"}
        </Button>
        {authError && (
          <div className="error">
            {" "}
            <ExclamationCircleFilled
              color="#2B0606"
              style={{ fontSize: "18px" }}
            />{" "}
            <p>{authError}</p>
          </div>
        )}
      </div>
    </LoginWrapper>
  );
};

export default SignInUICardStyled;
